import Footer from './Components/Footer';
import ShopIntro from './Components/ShopPage/ShopIntro';
import ShopOder from './Components/ShopPage/ShopOder';

const ShopPage = () => {
  return (
    <>
      <main className="ShopPage__main">
        <ShopIntro />
        <ShopOder />
      </main>
    </>
  );
};

export default ShopPage;
